export const NAME = 'scoringMachines';